/* Каждая страница админки — отдельный файл сборки, он скачивается при первом переходе на неё.
   Если скачать не вышло (обрыв связи, телефон только проснулся, выкладка новой версии), браузер
   помнит сбой до перезагрузки страницы: повторный переход падает тем же. Лечит только
   перезагрузка.

   Роутер перезагружает страницу сам, но один раз за всю жизнь вкладки на каждый текст ошибки, а
   у Safari текст всегда один — «Importing a module script failed.». Второй сбой в той же вкладке,
   хоть через сутки, оставлял сотрудника на экране ошибки до ручного ↻ (владелец, 27.09.2026).
   Здесь та же перезагрузка, но с ограничением по времени: не чаще раза в минуту, чтобы при
   настоящей поломке сервера страница не перезагружалась по кругу. */

const LAST_RELOAD_KEY = 'tt:chunk-reload-at';

/** Не чаще одной автоматической перезагрузки за это время. */
export const CHUNK_RELOAD_COOLDOWN_MS = 60_000;

const CHUNK_ERROR =
  /Importing a module script failed|Failed to fetch dynamically imported module|error loading dynamically imported module|Unable to preload CSS|Failed to load module script/i;

/** Ошибка — «не скачался файл сборки», а не поломка самой страницы. */
export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false;
  const message =
    error instanceof Error ? error.message : typeof error === 'string' ? error : String(error);
  return CHUNK_ERROR.test(message);
}

interface ReloadDeps {
  storage?: Pick<Storage, 'getItem' | 'setItem'> | null;
  now?: number;
  reload?: () => void;
}

/** Перезагрузить страницу, если прошлая такая перезагрузка была больше минуты назад. `true` —
 *  перезагрузка пошла. Без sessionStorage не перезагружаем вовсе: помнить, что уже пробовали,
 *  негде, и сломанный сервер закрутил бы страницу по кругу, — остаётся кнопка «Обновить». */
export function reloadAfterChunkError(deps: ReloadDeps = {}): boolean {
  const storage = deps.storage === undefined ? sessionStorageOrNull() : deps.storage;
  if (!storage) return false;
  const now = deps.now ?? Date.now();
  try {
    const last = Number(storage.getItem(LAST_RELOAD_KEY) ?? 0) || 0;
    if (now - last < CHUNK_RELOAD_COOLDOWN_MS) return false;
    storage.setItem(LAST_RELOAD_KEY, String(now));
  } catch {
    return false;
  }
  (deps.reload ?? (() => window.location.reload()))();
  return true;
}

function sessionStorageOrNull(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}
